export enum OrderMarketType {
  /** Первичный */
  Primary = 'Primary',
  /** Вторичный */
  Secondary = 'Secondary',
}
